import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { readStoredJson } from "utils/session";

const firebaseConfig = {
  apiKey: "AIzaSyCRJU7zHd-qdR2-BYxdJFKteT_wg_lTlCc",
  authDomain: "hypertrace-b0641.firebaseapp.com",
  projectId: "hypertrace-b0641",
  storageBucket: "hypertrace-b0641.firebasestorage.app",
  messagingSenderId: "705257175654",
  appId: "1:705257175654:web:deae31f4efa6704ceecba7",
  measurementId: "G-6W07PZQPKJ"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

const vapidKey = 'BM2e1whRcv4AGzXfZktUgR4H4PM8fVPEI9N43HljMz5eYgeK8MdfLs-coBLP7kr7ZYUphpevAWixtj-j2aH8veo'; 

export const requestFirebaseToken = async () => {
  try {
    // 2. Ask the user for permission to show popups
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      const token = await getToken(messaging, { vapidKey: vapidKey });
      if (token) {
        localStorage.setItem("fcmToken", token);
      }
      return token;
    } else {
      console.warn('Notification permission denied by user.');
      return null;
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

export const setupForegroundListener = () => {
  onMessage(messaging, (payload) => {
    console.log("Message received in foreground: ", payload);
    
    const notificationTitle = payload.notification?.title || "New Notification";
    const notificationBody = payload.notification?.body || "";
    
    // --- 1. Create the notification object ---
    const newNotif = {
      id: Date.now(), // Unique ID based on timestamp
      title: notificationTitle,
      body: notificationBody,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) // e.g., "03:41 PM"
    };

    // --- 2. Save it to localStorage ---
    const storedNotifs = readStoredJson("temp_notifications", []);
    const existingNotifs = Array.isArray(storedNotifs) ? storedNotifs : [];
    const updatedNotifs = [newNotif, ...existingNotifs]; // Put newest at the top
    localStorage.setItem('temp_notifications', JSON.stringify(updatedNotifs));

    // --- 3. Tell the Navbar to refresh its list ---
    window.dispatchEvent(new Event('new-fcm-notification'));

    // Force the browser popup
    const notificationOptions = {
      body: notificationBody,
      icon: '/logo192.png'
    };
    new Notification(notificationTitle, notificationOptions);
  });
};